"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pressedStyles = exports.hoverStyles = exports.AvatarButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const components_1 = require("./");
const Avatar_1 = require("./Avatar");
const Css_1 = require("../Css");
const useGetRef_1 = require("../hooks/useGetRef");
const utils_1 = require("../utils");
const getInteractiveElement_1 = require("../utils/getInteractiveElement");
const useTestIds_1 = require("../utils/useTestIds");
function AvatarButton(props) {
    const { onClick: onPress, disabled, autoFocus, buttonRef, tooltip, menuTriggerProps, openInNew, forceFocusStyles = false, ...avatarProps } = props;
    const isDisabled = !!disabled;
    const ariaProps = { onPress, isDisabled, autoFocus, ...menuTriggerProps };
    const ref = (0, useGetRef_1.useGetRef)(buttonRef);
    const { buttonProps, isPressed } = (0, react_aria_1.useButton)({
        ...ariaProps,
        onPress: typeof onPress === "string" ? utils_1.noop : onPress,
        elementType: typeof onPress === "string" ? "a" : "button",
    }, ref);
    const { focusProps, isFocusVisible } = (0, react_aria_1.useFocusRing)(ariaProps);
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)(ariaProps);
    const tid = (0, useTestIds_1.useTestIds)(props, avatarProps.name);
    const styles = (0, react_1.useMemo)(() => ({
        ...resetStyles,
        ...(isHovered && exports.hoverStyles),
        ...(isPressed && exports.pressedStyles),
        ...(isFocusVisible || forceFocusStyles ? focusStyles : {}),
        ...(isDisabled && disabledStyles),
    }), [isHovered, isFocusVisible, isDisabled, isPressed]);
    const buttonAttrs = {
        ...tid.button,
        ...buttonProps,
        ...focusProps,
        ...hoverProps,
        className: typeof onPress === "string" ? components_1.navLink : undefined,
        ref: ref,
        css: styles,
    };
    // If we're disabled b/c of a non-boolean ReactNode, or the caller specified tooltip text, then show it in a tooltip
    return (0, components_1.maybeTooltip)({
        title: (0, components_1.resolveTooltip)(disabled, tooltip),
        placement: "top",
        children: (0, getInteractiveElement_1.getButtonOrLink)((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { ...avatarProps, ...tid }), onPress, buttonAttrs, openInNew),
    });
}
exports.AvatarButton = AvatarButton;
const resetStyles = Css_1.Css.br100.cursorPointer.outline0.relative.$;
exports.hoverStyles = Css_1.Css.boxShadow(`0 0 4px ${Css_1.Palette.Gray900}`).$;
const focusStyles = Css_1.Css.bshFocus.$;
const disabledStyles = Css_1.Css.cursorNotAllowed.$;
exports.pressedStyles = Css_1.Css.addIn(":after", Css_1.Css.br100.bgGray900.contentEmpty.w100.h100.absolute.top0.left0.add("opacity", "0.2").$).$;
